import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { FetchAddExpenseReasonType } from "../../../domain/models/expense-dashboard/fetch-add-expense-reason";
import { FetchAddExpenseReason } from "../../../domain/useages/expense-dashboard/fetch-add-expense-reason";
import { RemoteFetchAddExpenseReason } from "../../../data/usecases/expense-dashboard/remote-fetch-add-expense-reason";

export interface FetchAddExpenseReasonInterface {
  FetchAddExpenseReason: FetchAddExpenseReasonType;
  FetchAddExpenseReasonState: FetchState;
  fetchAddExpenseReason: Function;
}

const initialStates = {
  FetchAddExpenseReason: {} as FetchAddExpenseReasonType,
  FetchAddExpenseReasonState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();

export const useFetchAddExpenseReasonSlice: StateCreator<
FetchAddExpenseReasonInterface
> = (set) => ({
  ...initialStates,
  fetchAddExpenseReason: async (params: FetchAddExpenseReason.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ??"";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteFetchAddExpenseReason= new RemoteFetchAddExpenseReason(
      `${BASE_URL}${Endpoints.FETCH_ADD_EXPENSE_REASON}`,
      axiosHttpClient
    );

    set(() => ({ FetchAddExpenseReasonState: FetchState.LOADING }));
    let result = await remoteFetchAddExpenseReason.fetch(params);
    return result;
  },
});
